<template>
  <v-card>
    <v-card-title>
      <v-toolbar-title>
        <slot/>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      v-if="employees.length > 0"
      :headers="headers"
      :items="employees"
      class="elevation-1"
      item-key="id"
      :pagination.sync="pagination"
      :search="search"
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>

      <template slot="items" slot-scope="props">
        <tr @click="selectedID = props.item.id">
          <td
            :class="`text-xs-${name.align}`"
            v-for="(name, index) in headers.filter(x => x.text !== 'Actions')"
            :key="index"
          >
            <v-radio-group
              class="text-xs-center"
              v-if="isSelectable && name.value == 'select'"
              v-model="selectedID"
              name="rowSelector"
              @change="GetSelectedEmployee()"
              column
            >
              <v-radio class="text-xs-right" :value="props.item.id"/>
            </v-radio-group>
            {{ props.item[name.value] }}
          </td>
          <td class="justify-center layout px-0" v-if="isEditable">
            <v-btn icon class="mx-0" @click="editItem(props.item)" title="Edit Employee">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import globalMixin from "@/mixins/globalMixin";

import { createNamespacedHelpers } from "vuex";
const { mapActions: mapEmployeeActions } = createNamespacedHelpers(`employees`);

export default {
	name: "EmployeesList",
	mixins: [globalMixin],
	props: {
		selected: { type: Array, required: true },
		isEditable: {
			type: Boolean,
			required: true
		},
		isSelectable: {
			type: Boolean,
			required: true
		},
		filterOut: {
			type: Array,
			required: false
		}
	},
	data () {
		return {
			employees: [],
			selectedID: 0
		};
	},
	methods: {
		...mapEmployeeActions(["GetAllEmployeesForDealer"]),
		editItem (item) {
			this.$emit("editEmployee", item);
		},
		GetSelectedEmployee () {
			this.$emit(
				"GetSelectedEmp",
				this.employees.filter(x => x.id == this.selectedID).map(x => x.dealerID)
			);
		},

		refreshList () {
			let vm = this;
			vm.GetAllEmployeesForDealer()
				.then(data => {
					vm.employees = data;
				})
				.catch(() => { });
		}
	},
	computed: {
		headers: function () {
			let headers = this.getHeaders(this.employees[0]);
			if (!this.isEditable) {
				headers = headers.filter(x => x.text !== "Actions");
			}

			return [
				{ align: "left", sortable: false, text: "Select", value: "select" },
				...headers
			];
		}
	},
	mounted () {
		this.refreshList();
	}
};
</script>

<style scoped>
</style>
